import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { TextField, Grid } from "@material-ui/core";

import { Page, Tabla } from "components";
import serviciosTablero from "utils/serviciosTablero";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";

const HistorialTablero = ({ idtablero, setCargando, setMensaje, ...props }) => {
  const [data, setData] = useState([]);
  const cerrarMensaje = () => setMensaje({ open: false });

  const columnas = [
    { label: "Tarjeta", name: "titulo", filtrar: true },
    { label: "Columna anterior", name: "anterior", filtrar: true },
    { label: "Columna Actual", name: "nuevo", filtrar: true },
    { label: "Responsable", name: "nombre", filtrar: true },
    { label: "Fecha movimiento", name: "fcrea", filtrar: true },
  ];

  useEffect(() => {
    serviciosTablero.getHistorialMovimientos(
      (status, mensaje, data) => {
        if (status < 0) {
          setMensaje({
            open: true,
            status: -1,
            value: "Error al obtener información.",
          });
          return;
        }

        setData(data?.historial || []);
      },
      setCargando,
      { idtablero: idtablero }
    );
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid xs={12}>
        <Tabla columns={columnas} rows={data} usarEstilosTablero={true} />
      </Grid>
    </Grid>
  );
};

export default HistorialTablero;
